import { render } from "./Actions.vue?vue&type=template&id=9f1715c6&scoped=true&ts=true"
import script from "./Actions.vue?vue&type=script&lang=ts"
export * from "./Actions.vue?vue&type=script&lang=ts"

import "./Actions.vue?vue&type=style&index=0&id=9f1715c6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f1715c6"]])

export default __exports__